import { cx } from "@emotion/css";

import { classCombinerFromPrefix } from "@/app/pages/upik/resources/RenderIdentifier";
import * as  ContainerStyles from "@/app/pages/upik/styles/ContainerStyles.module.scss";
import React from "react";
import { imprintURL } from "@/app/pages/upik/resources/constant";

const styles = ContainerStyles;

type FooterProps = {
    currentPagePath?: string;
    language: string | undefined;
    otherLanguagePageUrl: string;
};

const classCombiner = classCombinerFromPrefix("a43bb12b864a3f8f");

export const Footer = ({
    currentPagePath,
    language,
    otherLanguagePageUrl,
}: FooterProps): JSX.Element => {

    const getPageUrl = (linkName: string) => {
        if (linkName === "german") {
            if (language === "de") {
                return currentPagePath;
            }
            return otherLanguagePageUrl;
        }

        if (linkName === "english") {
            if (language === "en") {
                return currentPagePath;
            }
            return otherLanguagePageUrl;
        }

        return "#";
    };

    const germanTabClass = language === "de" ? "upikFooterLinkActive" : "upikFooterLink";
    const englishTabClass = language === "en" ? "upikFooterLinkActive" : "upikFooterLink";

    return (
        <div className={cx(classCombiner(styles, "upikFooterDesktopWrapper"))}>
            <div className={cx(classCombiner(styles, "footerSection"))}>
                <p>
                <a
                    className={cx(
                        classCombiner(styles, "footerLink")
                    )} 
                    target="_blank"
                    href={`${imprintURL}`} rel="noreferrer"
                >
                    {language === "de" ? "Impressum" : "Imprint"}
                </a>
                &nbsp;&nbsp;&nbsp;
                <a
                    className={cx(
                        classCombiner(styles, "footerLinkTermsOfUse")
                    )}
                    target="_blank"
                    href={language === "de" ? "/de-de/upik/nutzungsbedingungen.html" : "/de-de/upik-en/terms-of-use.html"}
                >
                    {language === "de" ? "Nutzungsbedingungen" : "Terms of use"}
                </a>                
                </p>
            </div>
        </div>
    );
};
